import Vue from 'vue'

const dateFormat = function(str, fmt) {
  const date = new Date(str)
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hours = date.getHours()
  const min = date.getMinutes()
  const second = date.getSeconds()
  const o = {
    'M+': month,
    'd+': day,
    'h+': hours,
    'm+': min,
    's+': second
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length))
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
    }
  }
  return fmt
}

Vue.filter('dateformat', dateFormat)

Vue.prototype.table_null_fmt = function(row, column, cellValue) {
  if(typeof row[column.property] == "number") {
    return row[column.property];
  }
  return row[column.property] || '-'
}
Vue.prototype.table_bool_fmt = function(row, column, cellValue) {
  return row[column.property] === 0 ? 'N' : 'Y'
}
Vue.prototype.date_format = dateFormat
Vue.prototype.table_date_fmt = function(row, column) {
  let time = row[column.property]
  return dateFormat(time, 'yyyy/MM/dd')
}
Vue.prototype.table_time_fmt = function(row, column) {
  let time = row[column.property]
  return time ? dateFormat(time, 'yyyy/MM/dd hh:mm:ss') : '-'
}



// WEBPACK FOOTER //
// ./src/config.js